import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const defaultEnvs = [
  {
    id: 'staging',
    name: 'Staging',
    color: 'yellow',
    variables: [
      { key: 'baseUrl', value: 'https://api-staging.albecollect.com', enabled: true, secret: false },
      { key: 'API_KEY', value: 'stg_key_xxxx', enabled: true, secret: true },
      { key: 'merchantID', value: '', enabled: true, secret: false },
      { key: 'secretKey', value: '', enabled: true, secret: true },
    ],
  },
  {
    id: 'uat',
    name: 'UAT',
    color: 'blue',
    variables: [
      { key: 'baseUrl', value: 'https://api-uat.albecollect.com', enabled: true, secret: false },
      { key: 'API_KEY', value: 'uat_key_xxxx', enabled: true, secret: true },
      { key: 'merchantID', value: '', enabled: true, secret: false },
      { key: 'secretKey', value: '', enabled: true, secret: true },
    ],
  },
];

export const useEnvironmentStore = create(
  persist(
    (set, get) => ({
      environments: defaultEnvs,
      activeEnvId: 'staging',

      activeEnv: () => {
        const s = get();
        return s.environments.find((e) => e.id === s.activeEnvId) || null;
      },

      resolveVariable: (str) => {
        const env = get().activeEnv();
        if (!env || !str) return str;
        return str.replace(/\{\{(\w+)\}\}/g, (_, key) => {
          const v = env.variables.find((v) => v.key === key && v.enabled);
          return v ? v.value : `{{${key}}}`;
        });
      },

      setActiveEnv: (id) => set({ activeEnvId: id }),

      addEnvironment: (env) =>
        set((s) => ({
          environments: [...s.environments, { ...env, id: Date.now().toString() }],
        })),

      updateEnvironment: (id, updates) =>
        set((s) => ({
          environments: s.environments.map((e) => (e.id === id ? { ...e, ...updates } : e)),
        })),

      deleteEnvironment: (id) =>
        set((s) => ({
          environments: s.environments.filter((e) => e.id !== id),
          activeEnvId: s.activeEnvId === id ? null : s.activeEnvId,
        })),
    }),
    {
      name: 'albecollect_environments',
      version: 4,
      migrate: () => ({ environments: defaultEnvs, activeEnvId: 'staging' }),
    }
  )
);
